export const BASE_URL = 'option-lists';

export const PATHS = {
  BASE_URL,
};

/** Same limits as the backend (`optionList` API operations). */
export const OPTION_LIST_MAX_ITEMS = 5000;
export const OPTION_LIST_LABEL_MAX_LENGTH = 100;
export const OPTION_LIST_NAME_MAX_LENGTH = 100;
